import { CurrencyCode, type CurrencyConfig } from "./types";

/**
 * 货币符号映射表
 */
export const CurrencySymbol = {
    [CurrencyCode.USD]: "$" as const,
    [CurrencyCode.EUR]: "€" as const,
    [CurrencyCode.CNY]: "¥" as const,
    [CurrencyCode.CENT]: "¢" as const,
    [CurrencyCode.INR]: "₹" as const,
};

/**
 * 货币配置映射表
 * 定义了每种货币的显示规则：
 * - 小数位精度
 * - 千分位/小数点符号
 * - 分组策略 (如印度 [3, 2])
 * - 缩放体系 (如印度单位制/国际单位制)
 */
export const CURRENCY_CONFIG_MAP: Record<CurrencyCode, CurrencyConfig> = {
    [CurrencyCode.USD]: {
        code: CurrencyCode.USD,
        symbol: CurrencySymbol[CurrencyCode.USD],
        decimalPlaces: 2,
        thousandSeparator: ",",
        decimalSeparator: ".",
        grouping: [ 3 ],
        unitSystem: "INTERNATIONAL",
    },
    [CurrencyCode.CENT]: {
        code: CurrencyCode.CENT,
        symbol: CurrencySymbol[CurrencyCode.CENT],
        decimalPlaces: 0,
        thousandSeparator: ",",
        decimalSeparator: ".",
        grouping: [ 3 ],
        unitSystem: "INTERNATIONAL",
    },
    [CurrencyCode.CNY]: {
        code: CurrencyCode.CNY,
        symbol: CurrencySymbol[CurrencyCode.CNY],
        decimalPlaces: 2,
        thousandSeparator: ",",
        decimalSeparator: ".",
        grouping: [ 3 ],
        unitSystem: "INTERNATIONAL",
    },
    [CurrencyCode.INR]: {
        code: CurrencyCode.INR,
        symbol: CurrencySymbol[CurrencyCode.INR],
        decimalPlaces: 2,
        thousandSeparator: ",",
        decimalSeparator: ".",
        grouping: [ 3, 2 ],
        unitSystem: "INDIAN",
    },
    [CurrencyCode.EUR]: {
        code: CurrencyCode.EUR,
        symbol: CurrencySymbol[CurrencyCode.EUR],
        decimalPlaces: 2,
        thousandSeparator: ".",
        decimalSeparator: ",",
        grouping: [ 3 ],
        unitSystem: "INTERNATIONAL",
    },
};
export const currency = CurrencySymbol[CurrencyCode.INR];
export const currencyCode = CurrencyCode.INR;
export { CurrencyCode };
